import { RoleGroups } from '@/router/roles';
import { anyOf } from '@/router/routeMeta.js';

export const publicRoutes = [
	{
		path: '/payout-setup/:result(complete|refresh)',
		name: 'payout-setup-return',
		meta: { auth: true },
		component: () => import('@/finance/views/PayoutSetupReturn.vue')
	},
	{
		path: '/account-deletion',
		name: 'account-deletion',
		meta: { public: true },
		component: () => import('@/views/pages/AccountDeletion.vue')
	},
	{
		path: '/account-deletion/confirm',
		name: 'account-deletion-confirm',
		meta: { auth: true },
		component: () => import('@/views/pages/AccountDeletionConfirm.vue')
	},
	{
		path: '/support',
		name: 'support',
		meta: { public: true },
		component: () => import('@/views/pages/Support.vue')
	},
	{
		path: '/privacy-policy',
		name: 'privacy-policy',
		meta: { public: true },
		component: () => import('@/views/pages/PrivacyPolicy.vue')
	},
	{
		path: '/',
		name: 'landing',
		component: () => import('@/views/pages/landing/Home.vue')
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('@/views/pages/auth/Login.vue')
	},
	{
		path: '/register',
		name: 'register',
		component: () => import('@/views/pages/auth/Register.vue')
	},
	{
		path: '/email/confirm',
		name: 'EmailConfirmRedirect',
		component: () => import('@/views/pages/auth/EmailConfirmRedirect.vue')
	},
	{
		path: '/api/v1/email/confirm',
		name: 'LegacyEmailConfirmRedirect',
		component: () => import('@/views/pages/auth/EmailConfirmRedirect.vue')
	},
	{
		path: '/email-confirmation',
		name: 'EmailConfirmationPrompt',
		component: () => import('@/views/pages/auth/EmailConfirmationPrompt.vue')
	},
	{
		path: '/group-signup',
		name: 'group-signup',
		component: () => import('@/views/pages/groupSignup/GroupSignupLanding.vue')
	},
	{
		path: '/group-signup/:token',
		name: 'group-signup-resume',
		component: () => import('@/views/pages/groupSignup/GroupSignupLanding.vue'),
		props: true
	},
	{
		path: '/payments/return',
		name: 'payments-return-redirect',
		redirect: (to) => ({
			path: '/app/settings',
			query: to.query
		})
	},
	{
		path: '/printable',
		name: 'printable',
		meta: anyOf(RoleGroups.ASSIGNORADMIN),
		component: () => import('@/views/RefereeAssignor/Dashboard/components/ad_printview.vue')
	},
	{
		path: 'access-denied',
		name: 'Public Access Denied',
		component: () => import('@/views/pages/AccessDenied/Access.vue')
	},
	{
		path: 'error',
		name: 'Public Error',
		component: () => import('@/views/pages/Error/Error.vue')
	},
	{
		path: '/:catchAll(.*)',
		name: 'Public Not Found',
		component: () => import('@/views/pages/NotFound/NotFound.vue')
	}
];
